

export class TraineeMedicalProcedureCaseParameterModel
{
    Id:string ;
    StudentMedicalProcedureCaseId:string;
    FacultyMedicalProcedureParameterId:string;
    ParameterName:string;
    ParameterValue:string;
}